import React from "react";
import classNames from "classnames";
import { MessagePriorities } from "../../../types/MessageType";

const TableRowPriorityColumn = ({ value }: Readonly<{ value: number | null | undefined }>) => {
    if (!value) {
        return <span className="py-1 px-2">-</span>
    }

    const className = [{
        'bg-priority-high text-priority-high': value === MessagePriorities.High,
        'bg-priority-medium text-priority-medium': value === MessagePriorities.Medium,
        'bg-priority-low text-priority-low': value === MessagePriorities.Low
    }];

    return <span className={classNames("badge py-1 px-2", className)}>
        {{
            [MessagePriorities.Low]: "Low",
            [MessagePriorities.Medium]: "Medium",
            [MessagePriorities.High]: "High"
        }[value]}
    </span>;
};

export default TableRowPriorityColumn;